import ToolbarButton from "./toolbar-button";
import { Pause, Play, SkipBack, SkipForward } from "@vitalsource/vstui-icons";
import React from "react";
import CircleButton from "./circle-button";
import styled from "styled-components";

const Styled = {
  Container: styled.div`
    & > *:nth-child(2) {
      margin: 0 11px;
    }
  `
};

const PlayButton = styled(Play)`
  /* https://medium.com/@erqiudao/the-play-button-is-not-optical-alignment-4cea11bda175 */
  margin-left: 2px;
`;

export default function CenterControls({
  onSkipForward,
  onPause,
  onPlay,
  onSkipBack,
  isPlaying,
  isReady,
  canNav
}) {
  return (
    <Styled.Container>
      <ToolbarButton
        label={i18n.t("tts.previous-section")}
        icon={<SkipBack />}
        onClick={onSkipBack}
        disabled={!isReady || !canNav}
      />
      {isPlaying ? (
        <CircleButton
          label={i18n.t("tts.pause")}
          icon={<Pause />}
          onClick={onPause}
          disabled={!isReady}
        />
      ) : (
        <CircleButton
          label={i18n.t("tts.play")}
          icon={<PlayButton />}
          onClick={onPlay}
          disabled={!isReady}
        />
      )}
      <ToolbarButton
        label={i18n.t("tts.next-section")}
        icon={<SkipForward />}
        onClick={onSkipForward}
        disabled={!isReady || !canNav}
      />
    </Styled.Container>
  );
}
